import styled from 'styled-components';
import { Modal } from 'ui-components/src/components/atoms/Modal';

export const StyledModal = styled(Modal)`
  width: 800px;
`;

export const Message = styled.p`
  line-height: 1.5;
`;

export const Header = styled.header`
  height: 50px;
  padding-left: 24px;
  margin-bottom: 8px;

  display: flex;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.greyWarm['20']};
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  & button {
    margin-right: 0.5rem;
  }
`;
